import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=2bbd8737&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=2bbd8737&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd8737",
  null
  
)

export default component.exports